import React from "react";
import SEO from "@/components/site/SEO";
import Reveal from "@/components/site/Reveal";

export default function Disclaimer() {
    return (
        <>
            <SEO
                title="Disclaimer & Regulatory Information | Acumen Financial Services"
                description="Acumen Financial Services Ltd regulatory disclosures, FCA authorisation details, fee schedule and company information."
                path="/disclaimer"
            />

            <section className="relative pt-28 pb-20 md:pt-36 md:pb-28 bg-brand-bg">
                <div className="mx-auto max-w-3xl px-6 md:px-10">
                    <Reveal>
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-brand-accent" />
                            <span className="text-xs uppercase tracking-[0.24em] text-brand-accent font-bold">
                                Regulatory information
                            </span>
                        </div>
                        <h1
                            data-testid="disclaimer-title"
                            className="font-serif-editorial text-5xl sm:text-6xl tracking-tight text-brand-primary leading-[1.05]"
                        >
                            Disclaimer.
                        </h1>
                    </Reveal>

                    <Reveal delay={0.05}>
                        <div className="mt-12 prose prose-lg max-w-none text-brand-text/85 leading-relaxed space-y-6">
                            <p>
                                <strong className="text-brand-primary">
                                    Acumen Financial Services Ltd
                                </strong>{" "}
                                (FRN: 1001151) is an appointed representative of{" "}
                                <strong className="text-brand-primary">
                                    HL Partnership Limited
                                </strong>{" "}
                                (FRN: 303397), which is authorised and regulated
                                by the Financial Conduct Authority. HL
                                Partnership Limited are responsible for advice
                                conducted on regulated mortgages, including
                                buy-to-let, protection, and general insurance
                                products.
                            </p>

                            <p>
                                There may be a fee for mortgage advice. The
                                precise amount of the fee will depend upon your
                                circumstances but will range from{" "}
                                <strong className="text-brand-primary">
                                    £449 to £799
                                </strong>{" "}
                                and this will be discussed and agreed with you
                                at the earliest opportunity.
                            </p>

                            <p>
                                Acumen Financial Services Ltd is registered in
                                Scotland. Registered Address: 2/3, 48 George
                                Street, Glasgow G2 1BP. Company number:{" "}
                                <strong className="text-brand-primary">
                                    SC725584
                                </strong>
                                .
                            </p>

                            <p>
                                The services described on this website are
                                available only to residents of the United
                                Kingdom and are subject to UK regulatory
                                jurisdiction.
                            </p>

                            <p className="text-sm text-brand-muted pt-8 border-t border-brand-border">
                                Your home may be repossessed if you do not keep
                                up repayments on your mortgage. ACUMEN
                                FINANCIAL SERVICES LTD · © {new Date().getFullYear()}{" "}
                                · All rights reserved.
                            </p>
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
